import { render, staticRenderFns } from "./vertical-menu-item.vue?vue&type=template&id=06e40cee&"
import script from "./vertical-menu-item.vue?vue&type=script&lang=js&"
export * from "./vertical-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./vertical-menu-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e40cee')) {
      api.createRecord('06e40cee', component.options)
    } else {
      api.reload('06e40cee', component.options)
    }
    module.hot.accept("./vertical-menu-item.vue?vue&type=template&id=06e40cee&", function () {
      api.rerender('06e40cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/vertical-menu-item.vue"
export default component.exports